import AccordionContainer from "../../common/accordion-container";
import { AddIcon } from "../../common/icons";
import WsClientTable from "./ws-client-table";
import './ws-client.scss';
import useToggle from "../../../hook/useToggle";
import WsClientCreate from "./ws-client-create";
import Button from "../../common/button";
import WsClientInfoPanel from "./ws-client-update";
import { useState } from "react";
import { IWsClient, IWsClientsResponse } from "../../../types/ws-admin";

const WsClient = () => {

    const { isOpen, toggle } = useToggle()

    const [selectedClient, setSelectedClient] = useState<IWsClient>()

    const handleSelectedClient = (client: IWsClient) => {
        setSelectedClient(client)
    }
    

    return (
        <>
            <div>
                <Button type="button" aria-label="Create New Client" color="primary" onClick={toggle}>
                    <AddIcon /> Create new Client
                </Button>
            </div>
            <AccordionContainer title="Clients">
                {/* Pass the onClientSelect function as a prop to the table component*/}
                <WsClientTable onClientSelect={handleSelectedClient}/>
            </AccordionContainer>

            <WsClientCreate isOpen={isOpen} toggle={toggle}/>
            
            {selectedClient && <WsClientInfoPanel client={selectedClient} />}

        </>
    )

}

export default WsClient
